/**
 * Valida se o valor é um número decimal (ou vazio).
 * Aceita inteiros (ex.: 1, 78) e decimais (ex.: 1.5, 0,25).
 * @param {*} valor - Valor a validar (string, number, null, undefined).
 * @returns {boolean} true se for vazio ou número válido; false caso contrário.
 */
const validarNumeroDecimal = (valor) => {
  if (valor === "" || valor === undefined || valor === null) return true;
  const n = Number(valor);
  return !Number.isNaN(n);
};

export default validarNumeroDecimal;
